import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getReturnPolicy } from '../../../actions/pagesActions';
import { StateType } from '../../../reducers';
import MainLayout from '../../layouts/MainLayout';

const ReturnPolicy = () => {
    const { returnPolicy } = useSelector((state: StateType) => state.pages);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!returnPolicy) dispatch(getReturnPolicy());
    }, [dispatch, returnPolicy]);

    return (
        <MainLayout mainClassname="bg-white">
            <section className="bg-gray-1 text-center px-3 py-5 mb-4">
                <h1 className="mt-3 text-inter text-700 text-36 text-dark-color">
                    Return Policy
                </h1>
            </section>

            {!!returnPolicy && (
                <section
                    className="app-container py-4"
                    dangerouslySetInnerHTML={{ __html: returnPolicy }}
                />
            )}
        </MainLayout>
    );
};

export default ReturnPolicy;
